import * as types from './types';
import createReducer from '../../createReducer';
import { FETCH_STATE } from 'constants/common';

const initialState = {
  loading: false,
  pagination: {},
  fetchingDeleteSku: false,
  fetchedDeleteSku: false,
  items: [],
  fetchedCreateSku: false,
  fetchingSku: false,
  sku: {},
  onboarding: {
    exitOnboarding: false,
    currentSku: '',
    exitStep: false,
    lastStep: false,
    position: 0,
    errors: {},
    steps: {},
  },
  associatedTaxRuleset: [],
  associatedTaxRulesetPagination: {},
  fetchingAssociatedTaxRuleset: FETCH_STATE.UNSENT,
};

const skusReducer = createReducer(initialState)({
  [types.FETCH_SKUS_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_SKUS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      items: payload.data,
      pagination: payload.pagination,
    };
  },
  [types.FETCH_SKUS_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  // FETCH SKU BY ID
  [types.FETCH_SKU_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      fetchingSku: true,
    };
  },
  [types.FETCH_SKU_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingSku: false,
      sku: payload.data,
    };
  },
  [types.FETCH_SKU_BY_ID_FAILED]: (state) => {
    return {
      ...state,
      fetchingSku: false,
    };
  },
  // DELETE SKU
  [types.FETCH_DELETE_SKU_REQUEST]: (state) => {
    return {
      ...state,
      fetchingDeleteSku: true,
      fetchedDeleteSku: false,
    };
  },
  [types.FETCH_DELETE_SKU_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingDeleteSku: false,
      fetchedDeleteSku: true,
    };
  },
  [types.FETCH_DELETE_SKU_FAILED]: (state) => {
    return {
      ...state,
      fetchingDeleteSku: false,
      fetchedDeleteSku: false,
    };
  },
  // UPDATE SKU
  [types.FETCH_UPDATE_SKU_REQUEST]: (state) => {
    return {
      ...state,
      fetchingUpdateSku: true,
      fetchedUpdateSku: false,
      onboarding: {
        ...state.onboarding,
        errors: {},
      },
    };
  },
  [types.FETCH_UPDATE_SKU_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingUpdateSku: false,
      fetchedUpdateSku: true,
    };
  },
  [types.FETCH_UPDATE_SKU_FAILED]: (state, { errors }) => {
    return {
      ...state,
      fetchingUpdateSku: false,
      fetchedUpdateSku: false,
      onboarding: {
        errors,
      },
    };
  },
  // ONBOARDING CHANGE POSITION
  [types.CHANGE_POSITION]: (state, { payload }) => {
    let data = {};
    if (payload.data && payload.step) {
      data = {
        steps: {
          ...state.onboarding?.steps,
          [payload.step]: payload.data,
        },
      };
    }
    return {
      ...state,
      onboarding: {
        ...state.onboarding,
        position: payload.position,
        ...data,
      },
    };
  },
  // RESET ONBOARDING
  [types.RESET_ONBOARDING]: (state) => {
    return {
      ...state,
      fetchedCreateSku: false,
      onboarding: {
        exitOnboarding: false,
        currentSku: '',
        exitStep: false,
        lastStep: false,
        position: 0,
        errors: {},
        steps: {},
      },
    };
  },

  [types.SET_EXIT]: (state, { payload }) => {
    return {
      ...state,
      onboarding: {
        ...state.onboarding,
        [payload.type]: payload.exit,
      },
    };
  },

  // FETCH CREATE SKU
  [types.FETCH_CREATE_SKU_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchedCreateSku: false,
    };
  },
  [types.FETCH_CREATE_SKU_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      sku: payload,
      fetchedCreateSku: true,
    };
  },
  [types.FETCH_CREATE_SKU_FAILED]: (state, { errors, payload }) => {
    return {
      ...state,
      loading: false,
      onboarding: {
        ...state.onboarding,
        errors,
        steps: {
          ...state.onboarding?.steps,
          behaviour: payload,
        },
      },
      fetchedCreateSku: false,
    };
  },

  // FETCH CREATE SKU
  [types.FETCH_ASSOCIATED_TAX_RULESET_REQUEST]: (state) => {
    return {
      ...state,
      fetchingAssociatedTaxRuleset: FETCH_STATE.LOADING,
      associatedTaxRuleset: [],
      associatedTaxRulesetPagination: {},
    };
  },
  [types.FETCH_ASSOCIATED_TAX_RULESET_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingAssociatedTaxRuleset: FETCH_STATE.DONE,
      associatedTaxRuleset: payload.data,
      associatedTaxRulesetPagination: payload.pagination,
    };
  },
  [types.FETCH_ASSOCIATED_TAX_RULESET_FAILED]: (state, { errors, payload }) => {
    return {
      ...state,
      fetchingAssociatedTaxRuleset: FETCH_STATE.ERROR,
      errors,
    };
  },
});

export default skusReducer;
